import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../Components/consts'

export const SelectBottom = styled('div')(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 999,
  background: colors.darkBackground,
  borderTop: `solid 1px ${colors.gray.gray20}`,
}))

export const SelectOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const SelectInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: theme.spacing(1, 2),
  minHeight: 60,
  width: '100%',
  maxWidth: 1200,
  '& button': {
    cursor: 'pointer',
    padding: theme.spacing(2, 5),
    borderRadius: theme.spacing(3),
    fontSize: fontSizes.semiLarge,
    fontWeight: 'bold',
    color: colors.black,
    backgroundColor: colors.white,
    marginRight: theme.spacing(1),
    minWidth: 120,
    textAlign: 'center',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
      padding: theme.spacing(1, 3),
      minWidth: 80,
    },
  },
  '& a': {
    cursor: 'pointer',
    textDecoration: 'none',
    padding: theme.spacing(2, 5),
    borderRadius: theme.spacing(3),
    fontSize: fontSizes.semiLarge,
    fontWeight: 'bold',
    color: colors.black,
    backgroundColor: colors.white,
    marginRight: theme.spacing(1),
    minWidth: 120,
    textAlign: 'center',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
      padding: theme.spacing(1, 3),
      minWidth: 80,
    },
  },
}))

export const WelcomeCon = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: 150,
      [theme.breakpoints.down('sm')]: {
        width: 100,
      },
    },
    '& h2': {
      fontWeight: 700,
      fontSize: fontSizes.semiLarge,
      color: colors.white,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.medium,
      },
    },
  }))

export const ShareCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  margin: theme.spacing(2, 1),
  '& .textField': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: colors.gray.gray60,
    borderRadius: 12,
    margin: theme.spacing(0, 2),
    padding: theme.spacing(2, 3),
    '& .linkText': {
      fontSize: fontSizes.medium,
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.small,
      },
    },
  },
  '& button': {
    cursor: 'pointer',
    padding: theme.spacing(0, 3),
    borderRadius: theme.spacing(3),
    fontSize: fontSizes.semiLarge,
    fontWeight: 'bold',
    color: colors.black,
    backgroundColor: colors.white,
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
}))
